module.exports = global["_"] = require("-!./once.js");